import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SellerShowcasePageRoutingModule } from './seller-showcase-routing.module';

import { SellerShowcasePage } from './seller-showcase.page';
import { SharedModule } from '@shared/shared.module';
import { SellerShowcaseDivisionalPromotionsComponent } from './components/seller-showcase-divisional-promotions/seller-showcase-divisional-promotions.component';
import { SellerShowcaseDivisionalPromotionComponent } from './components/seller-showcase-divisional-promotion/seller-showcase-divisional-promotion.component';
import { ListSharedModule } from '@app/lists/shared/list-shared.module';
import { SellerShowcaseFiltersBaseComponent } from './components/seller-showcase-filters/seller-showcase-filters-base.component';
import { SellerShowcaseFiltersMobileComponent } from './components/seller-showcase-filters/seller-showcase-filters-mobile/seller-showcase-filters-mobile.component';
import { SellerShowcaseFiltersInputMobileComponent } from './components/seller-showcase-filters/seller-showcase-filters-mobile/seller-showcase-filters-input-mobile/seller-showcase-filters-input-mobile.component';
import { SellerShowcaseFiltersDesktopTabletComponent } from './components/seller-showcase-filters/seller-showcase-filters-desktop-tablet/seller-showcase-filters-desktop-tablet.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ListSharedModule,
    SharedModule,
    SellerShowcasePageRoutingModule,
  ],
  declarations: [
    SellerShowcasePage,
    SellerShowcaseDivisionalPromotionsComponent,
    SellerShowcaseDivisionalPromotionComponent,
    SellerShowcaseFiltersBaseComponent,
    SellerShowcaseFiltersDesktopTabletComponent,
    SellerShowcaseFiltersMobileComponent,
    SellerShowcaseFiltersInputMobileComponent,
  ],
})
export class SellerShowcaseModule {}
